/**
 * Constants for report parameters and dynamic options
 */
export const DYNAMIC_OPTIONS = {
  IE_KITS: 'ie-kits',
  SHELF_MAP_LAYOUTS: 'shelf-map-layouts',
  /** Locations within a shelf map layout (depends on the selected layoutId). */
  SHELF_MAP_LOCATIONS: 'shelf-map-locations',
  /** Distinct person entity_data.billet values (Workforce Category), unscoped. */
  WORKFORCE_CATEGORIES: 'workforce-categories',
  /** Section values scoped to the selected Workforce Category. */
  SECTIONS_BY_WORKFORCE_CATEGORY: 'sections-by-workforce-category',
  /** Parent NSN options scoped to the selected Workforce Category (and optional Section). */
  PARENT_NSN_BY_WORKFORCE_CATEGORY: 'parent-nsn-by-workforce-category',
  /** All locations in the system, for reports that filter by a single location. */
  LOCATIONS: 'locations',
} as const;

export type DynamicOptionType = (typeof DYNAMIC_OPTIONS)[keyof typeof DYNAMIC_OPTIONS];
